export interface ArchiveEntry {
  id: string;
  title: string;
  type: string;
  typeKey: string;
  groupBy: string;
  date: string;
  desc: string;
}

export const archiveEntries: ArchiveEntry[] = [
  { id: "a1", title: "小川望春访谈全记录", type: "动画", typeKey: "anime", groupBy: "作者归档", date: "2026-08-12", desc: "按导演整理的访谈与特典资料目录" },
  { id: "a2", title: "森井直子少女漫画卷宗", type: "漫画", typeKey: "manga", groupBy: "作者归档", date: "2026-08-09", desc: "按作者整理的漫画单行本与短篇索引" },
  { id: "a3", title: "星海林野冒险游戏系列", type: "游戏", typeKey: "game", groupBy: "系列归档", date: "2026-08-05", desc: "按系列整理的历代版本与 DLC 对照" },
  { id: "a4", title: "月光文库轻小说补全索引", type: "轻小说", typeKey: "novel", groupBy: "文库归档", date: "2026-07-30", desc: "按文库整理的卷次与连载进度索引" },
  { id: "a5", title: "光流美知留声优出演表", type: "声优", typeKey: "voice", groupBy: "作者归档", date: "2026-07-24", desc: "按声优整理的出演作品与角色索引" },
  { id: "a6", title: "枫柯绘集同人画作归档", type: "同人", typeKey: "fanwork", groupBy: "作者归档", date: "2026-07-18", desc: "按作者整理的画集与展贩本目录" },
  { id: "a7", title: "春风短篇动画精选", type: "动画", typeKey: "anime", groupBy: "系列归档", date: "2026-07-10", desc: "按企划整理的短篇动画片单" },
  { id: "a8", title: "光河《星际少年》卷宗", type: "漫画", typeKey: "manga", groupBy: "作品归档", date: "2026-07-03", desc: "按作品整理的全卷与设定集索引" },
  { id: "a9", title: "早川轻小说连载归档", type: "轻小说", typeKey: "novel", groupBy: "文库归档", date: "2026-06-28", desc: "按文库整理的连载进度与卷次对照" },
  { id: "a10", title: "青叶独立游戏同人合集", type: "游戏", typeKey: "game", groupBy: "系列归档", date: "2026-06-21", desc: "按系列整理的独立游戏资源目录" },
  { id: "a11", title: "水无月声优广播剧索引", type: "声优", typeKey: "voice", groupBy: "作者归档", date: "2026-06-15", desc: "按声优整理的广播剧与朗读作品索引" },
  { id: "a12", title: "盛夏同人展贩本归档", type: "同人", typeKey: "fanwork", groupBy: "活动归档", date: "2026-06-08", desc: "按活动整理的展会贩本与画集目录" },
];

export const groupOptions = ["全部", "作者归档", "系列归档", "作品归档", "文库归档", "活动归档"];
export const typeOptions = ["全部", "动画", "漫画", "游戏", "轻小说", "声优", "同人"];